import {Outlet} from '@github-ui/react-router'

import {GlobalNavBar} from '@github-ui/global-navigation/bar'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {appShellLayoutRoute} from './app-shell-layout-route'

export function AppShellLayout() {
  const payload = useRouteQuery(appShellLayoutRoute, 'mainQuery')

  const {globalNavigation} = payload?.data ?? {}

  return (
    <div>
      {/* TODO: Add fallback */}
      {globalNavigation && <GlobalNavBar {...globalNavigation} />}
      <Outlet />
    </div>
  )
}

try{ AppShellLayout.displayName ||= 'AppShellLayout' } catch {}